<template>
  <div class="ecm__cost">
    <el-dialog
      title="Courier"
      :visible.sync="isShow"
      width="35%"
    >
      <el-tabs v-model="activeName" tab-position="left">
        <el-tab-pane v-if="handleCheckCourier(tiki)" label="TIKI" name="tiki">
          <div v-for="(courier, i) in tiki" :key="i" class="ecm__cost-courier">
            <div v-for="(cost, j) in courier.costs" :key="j">
              <p class="ecm__cost-courier__title">{{cost.service}} ({{ cost.description }})</p>
              <div
                :class="courierLocal.costId == price.id ? 'ecm__cost-courier__cost active' : 'ecm__cost-courier__cost'"
                v-for="(price, k) in cost.cost" :key="k"
                @click="handleCheckCostCourier(courier.name, price.id, price.value, price.etd, courier.code)"
              >
                <div class="ecm__cost-courier__cost-desc">
                  <p>Rp {{ formatPrice(price.value) }}</p>
                  <p>estimate {{ formatDaysCourier(price.etd) }}</p>
                </div>
                <button v-if="courierLocal.costId == price.id" class="ecm__cost-courier__cost-check">
                  <i class="fas fa-check"></i>
                </button>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="handleCheckCourier(jne)" label="JNE" name="jne">
          <div v-for="(courier, i) in jne" :key="i" class="ecm__cost-courier">
            <div v-for="(cost, j) in courier.costs" :key="j">
              <p class="ecm__cost-courier__title">{{cost.service}} ({{ cost.description }})</p>
              <div
                :class="courierLocal.costId == price.id ? 'ecm__cost-courier__cost active' : 'ecm__cost-courier__cost'"
                v-for="(price, k) in cost.cost" :key="k"
                @click="handleCheckCostCourier(courier.name, price.id, price.value, price.etd, courier.code)"
              >
                <div class="ecm__cost-courier__cost-desc">
                  <p>Rp {{ formatPrice(price.value) }}</p>
                  <p>estimate {{ formatDaysCourier(price.etd) }}</p>
                </div>
                <button v-if="courierLocal.costId == price.id" class="ecm__cost-courier__cost-check">
                  <i class="fas fa-check"></i>
                </button>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="handleCheckCourier(pos)" label="POS" name="pos">
          <div v-for="(courier, i) in pos" :key="i" class="ecm__cost-courier">
            <div v-for="(cost, j) in courier.costs" :key="j">
              <p class="ecm__cost-courier__title">{{cost.service}} ({{ cost.description }})</p>
              <div
                :class="courierLocal.costId == price.id ? 'ecm__cost-courier__cost active' : 'ecm__cost-courier__cost'"
                v-for="(price, k) in cost.cost" :key="k"
                @click="handleCheckCostCourier(courier.name, price.id, price.value, price.etd, courier.code)"
              >
                <div class="ecm__cost-courier__cost-desc">
                  <p>Rp {{ formatPrice(price.value) }}</p>
                  <p>estimate {{ formatDaysCourier(price.etd) }}</p>
                </div>
                <button v-if="courierLocal.costId == price.id" class="ecm__cost-courier__cost-check">
                  <i class="fas fa-check"></i>
                </button>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import formatDisplay from '@/mixins/formatDisplay.js'

export default {
  name: 'Cost',
  mixins: [formatDisplay],
  props: {
    courier: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isShow: false,
      activeName: 'tiki',
      isChecked: false
    }
  },
  computed: {
    ...mapState({
      jne: state => state.cost.jne,
      pos: state => state.cost.pos,
      tiki: state => state.cost.tiki
    }),
    courierLocal: {
      get () {
        return this.$props.courier
      },
      set (payload) {
        this.$props.courier = payload
      }
    }
  },
  methods: {
    setIsShow (payload) {
      this.$data.isShow = payload
    },
    setActiveTab () {
      this.$data.activeName = this.courierLocal.code
    },
    handleCheckCourier (courier) {
      let getCosts = false
      courier.forEach(service => {
        if (service.costs.length) {
          service.costs.forEach(cost => {
            if (cost.cost.length > 0) {
              getCosts = true
              return true
            }
          })
        }
      })

      return getCosts
    },
    handleCheckCostCourier (courierName, costId, cost, etd, code) {
      this.$emit('handleCourierCost', {
        courierName,
        costId,
        cost,
        etd,
        code
      })
      this.setIsShow(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__cost {
  position: absolute;
  &::v-deep .el-dialog__wrapper {
    .el-dialog {
      padding: 20px;
      .el-dialog__header {
        padding: 0;
        .el-dialog__title {
          font-weight: 500;
          font-size: 20px;
          color: var(--color-blue-background);
        }
      }
      .el-dialog__body {
        padding: 20px 0 0 0;
        .el-tabs {
          .el-tabs__header {
            .el-tabs__nav-wrap {
              .el-tabs__nav-scroll {
                .el-tabs__nav {
                  .el-tabs__active-bar {
                    background: yellow;
                  }
                  .el-tabs__item {
                    color: var(--color-blue-background);
                    transition: .2s;
                    &.is-active {
                      background: var(--color-blue-background);
                      color: white;
                    }
                    &.is-left {
                      text-align: left;
                    }
                  }
                }
              }
            }
          }
          .el-tabs__content {
            ::-webkit-scrollbar {
              width: 7px;
            }
            /* Track */
            ::-webkit-scrollbar-track {
              background: #f1f1f1;
            }
            /* Handle */
            ::-webkit-scrollbar-thumb {
              background: #888;
              border-radius: 10px;
            }
            /* Handle on hover */
            ::-webkit-scrollbar-thumb:hover {
              background: #555;
            }
            .el-tab-pane {
              height: 200px;
              width: 100%;
              overflow-y: auto;
              padding-right: 5px;
              .ecm__cost-courier {
                .ecm__cost-courier__title {
                  color: var(--color-blue);
                  font-weight: 700;
                  margin-bottom: 5px;
                }
                .ecm__cost-courier__cost {
                  padding: 1px 10px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  border: 1px solid rgb(209, 209, 209);
                  cursor: pointer;
                  font-weight: 500;
                  color: rgba(0, 0, 0, 0.788);
                  &.active,
                  &:hover {
                    background: var(--color-blue-background);
                    color: white;
                    border: 1px solid var(--color-blue-background);
                    .ecm__cost-courier__cost-check {
                      color: white;
                    }
                  }
                  .ecm__cost-courier__cost-check {
                    border: none;
                    background: none;
                    outline: none;
                    color: var(--color-blue-background);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
